import { ItemCell } from "./ItemCell";
import { CustomerDataCell } from "./CustomerDataCell";
import { ColDef } from "ag-grid-community";
import { ConsignmentCell } from "./ConsignmentCell";
import { OrderIdCell } from "./OrderIdCell";
import { ActionCell } from "./ActionCell";
import { OrderIdHeader } from "./OrderIdHeader";
import { PreSelectedQuoteCell } from "./PreSelectedQuoteCell";
import { ActionsHeader } from "./ActionsHeader";
import { OrderPrivateNotes } from "../OrdersTable/OrderPrivateNotes";
import { OrdersPricingCell } from "../OrdersTable/OrderPricing";
import { OrderStateCell } from "./OrderStateCell";
import { SHIPMENTS_TABLE_TABS } from "../../constants";

export const shipmentTableColumnsData = ({
  onRefreshData,
  setSnackBar,
  shipmentTab,
}: {
  onRefreshData?: () => void;
  setSnackBar: (snackbarState: { open: boolean; message: string; severity: string }) => void;
  shipmentTab: string;
}) => {
  const baseColumns: ColDef[] = [
    {
      headerName: "Order ID",
      field: "orderID",
      width: 250,
      pinned: "left",
      checkboxSelection: true,
      headerCheckboxSelection: true,
      headerCheckboxSelectionFilteredOnly: true,
      cellRenderer: OrderIdCell,
      sortable: false,
      headerComponent: OrderIdHeader,
    },
    {
      headerName: "Item",
      field: "item",
      width: 800,
      cellRenderer: ItemCell,
      autoHeight: true,
      wrapText: true,
      sortable: false,
    },
    {
      headerName: "Pricing Details",
      field: "orderPricing",
      width: 250,
      cellRenderer: OrdersPricingCell,
      autoHeight: true,
      wrapText: true,
      sortable: false,
      cellStyle: (params) => {
        return { alignItems: "flex-start", padding: "8px" };
      },
      cellRendererParams: { refreshData: onRefreshData, setSnackBar },
    },
    {
      headerName: "Preselected quotes",
      field: "labelNumber",
      width: 300,
      cellRenderer: PreSelectedQuoteCell,
      autoHeight: true,
      wrapText: true,
      sortable: false,
      cellStyle: (params) => {
        return { alignItems: "flex-start", padding: "8px" };
      },
      cellRendererParams: { refreshData: onRefreshData, setSnackBar },
    },
    {
      headerName: "Consignment",
      field: "labelNumber",
      width: 400,
      cellRenderer: ConsignmentCell,
      autoHeight: true,
      wrapText: true,
      sortable: false,
      cellStyle: (params) => {
        return { alignItems: "flex-start", padding: "8px" };
      },
      cellRendererParams: {
        refreshData: onRefreshData,
        setSnackBar,
      },
    },
    {
      headerName: "Customer Contact",
      field: "shipToPhone",
      width: 300,
      cellRenderer: CustomerDataCell,
      autoHeight: true,
      wrapText: true,
      sortable: false,
      cellStyle: (params) => {
        return { alignItems: "flex-start", padding: "8px" };
      },
    },
    {
      headerName: "Internal Notes",
      field: "internalNote",
      cellRenderer: OrderPrivateNotes,
      cellRendererParams: {
        refreshData: onRefreshData,
        setSnackBar,
      },
      width: 300,
      autoHeight: true,
      wrapText: true,
      sortable: false,
      cellStyle: (params) => {
        return { alignItems: "flex-start", padding: "8px" };
      },
    },
    { headerName: "Error", field: "error", width: 250, sortable: false },
    {
      headerName: "Actions",
      width: 300,
      pinned: "right",
      sortable: false,
      cellRenderer: ActionCell,
      cellRendererParams: {
        refreshData: onRefreshData,
        setSnackBar,
      },
      headerComponent: ActionsHeader,
      headerComponentParams: {
        refreshData: onRefreshData,
        setSnackBar,
      },
    },
  ];

  // Add the special column at index 2 if shipmentTab is 3
  if (shipmentTab === SHIPMENTS_TABLE_TABS.ALL_ORDERS.value) {
    const specialColumn: ColDef = {
      headerName: "Order State",
      field: "orderState",
      width: 300,
      cellRenderer: OrderStateCell,
      autoHeight: true,
      wrapText: true,
      sortable: false,
      cellStyle: (params) => {
        return { alignItems: "flex-start", padding: "8px" };
      },
      cellRendererParams: {
        refreshData: onRefreshData,
        setSnackBar,
      },
    };

    baseColumns.splice(2, 0, specialColumn); // Insert at index 2
  }

  return baseColumns;
};
